/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Before_5Inputs */

const en_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letters that sound like everyone else's`)
};

const de_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben, die wie alle anderen klingen`)
};

const fr_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lettres de motivation qui ressemblent à celles de tout le monde`)
};

const es_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación que suenan igual que las de todos`)
};

const it_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione uguali a quelle di tutti gli altri`)
};

const nl_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrieven die klinken als die van iedereen`)
};

const pl_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne brzmiące jak wszystkie inne`)
};

const fi_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjeet, jotka kuulostavat kaikilta muilta`)
};

const da_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve der lyder som alle andres`)
};

const sv_landing_before_5 = /** @type {(inputs: Landing_Before_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personliga brev som låter som alla andras`)
};

/**
* | output |
* | --- |
* | "Cover letters that sound like everyone else's" |
*
* @param {Landing_Before_5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_before_5 = /** @type {((inputs?: Landing_Before_5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Before_5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_before_5(inputs)
	if (locale === "fr") return fr_landing_before_5(inputs)
	if (locale === "es") return es_landing_before_5(inputs)
	if (locale === "it") return it_landing_before_5(inputs)
	if (locale === "nl") return nl_landing_before_5(inputs)
	if (locale === "pl") return pl_landing_before_5(inputs)
	if (locale === "fi") return fi_landing_before_5(inputs)
	if (locale === "da") return da_landing_before_5(inputs)
	if (locale === "sv") return sv_landing_before_5(inputs)
	return en_landing_before_5(inputs)
});